export default __webpack_public_path__ + "static/media/FaviconCLear.e85fe782.png";